import RessourceReducerFactory from 'helpers/RessourceReducerFactoryHelpers';
import RessourceSelectorsFactory from 'helpers/RessourceSelectorsFactoryHelpers';
import {
    default as createActionCreator,
    HTTP_METHODS,
} from 'helpers/RessourceActionCreatorsFactoryHelpers';

/*
 * Configuration
 */
export const ressourceName = 'ORGA';
export const ressourceNamePlural = 'ORGAS';

/*
 * Actions
 */

export const REQUEST_GET_ORGAS = `REQUEST_GET_${ressourceNamePlural}`;
export const REQUEST_GET_ORGAS_SUCCESS = `REQUEST_GET_${ressourceNamePlural}_SUCCESS`;
export const REQUEST_GET_ORGAS_ERROR = `REQUEST_GET_${ressourceNamePlural}_ERROR`;

export const REQUEST_GET_ORGA = `REQUEST_GET_${ressourceName}`;
export const REQUEST_GET_ORGA_SUCCESS = `REQUEST_GET_${ressourceName}_SUCCESS`;
export const REQUEST_GET_ORGA_ERROR = `REQUEST_GET_${ressourceName}_ERROR`;

export const REQUEST_POST_ORGA = `REQUEST_POST_${ressourceName}`;
export const REQUEST_POST_ORGA_SUCCESS = `REQUEST_POST_${ressourceName}_SUCCESS`;
export const REQUEST_POST_ORGA_ERROR = `REQUEST_POST_${ressourceName}_ERROR`;

export const REQUEST_PUT_ORGA = `REQUEST_PUT_${ressourceName}`;
export const REQUEST_PUT_ORGA_SUCCESS = `REQUEST_PUT_${ressourceName}_SUCCESS`;
export const REQUEST_PUT_ORGA_ERROR = `REQUEST_PUT_${ressourceName}_ERROR`;

export const REQUEST_DELETE_ORGA = `REQUEST_DELETE_${ressourceName}`;
export const REQUEST_DELETE_ORGA_SUCCESS = `REQUEST_DELETE_${ressourceName}_SUCCESS`;
export const REQUEST_DELETE_ORGA_ERROR = `REQUEST_DELETE_${ressourceName}_ERROR`;

export const SET_ORGAS_PAGE = `SET_${ressourceNamePlural}_PAGE`;
export const SET_ORGAS_PAGE_SIZE = `SET_${ressourceNamePlural}_PAGE_SIZE`;
export const FLUSH_ORGAS = `FLUSH_${ressourceNamePlural}`;

/*
 * Reducer
 */

export const APIOrgasReducer = RessourceReducerFactory({
    ressourceName,
    ressourceNamePlural,
});

/*
 * Action Creators
 */

export const getOrgas = createActionCreator({
    type: REQUEST_GET_ORGAS,
    method: HTTP_METHODS.GET,
    url: '/orgas',
    withPagination: true,
});

export const getOrga = createActionCreator({
    type: REQUEST_GET_ORGA,
    method: HTTP_METHODS.GET,
    url: '/orgas/:id',
    withPagination: false,
});

export const postOrga = createActionCreator({
    type: REQUEST_POST_ORGA,
    method: HTTP_METHODS.POST,
    url: '/orgas',
    withPagination: false,
});

export const putOrga = createActionCreator({
    type: REQUEST_PUT_ORGA,
    method: HTTP_METHODS.PUT,
    url: '/orgas/:id',
    withPagination: false,
});

export const deleteOrga = createActionCreator({
    type: REQUEST_DELETE_ORGA,
    method: HTTP_METHODS.DELETE,
    url: '/orgas/:id',
    withPagination: false,
});

/**
 * Create a SET_ORGAS_PAGE action
 * @param {integer} page The page to set
 */
export function setOrgasPage(page) {
    return {
        type: SET_ORGAS_PAGE,
        payload: {
            page,
        },
    };
}

/**
 * Create a SET_ORGAS_PAGE_SIZE action
 * @param {integer} pageSize The page size
 */
export function setOrgasPageSize(pageSize) {
    return {
        type: SET_ORGAS_PAGE_SIZE,
        payload: {
            pageSize,
        },
    };
}

/**
 * Create a FLUSH_ORGAS action
 */
export function flushOrgas() {
    return {
        type: FLUSH_ORGAS,
    };
}

/*
 * Selectors
 */
export const {
    getItemSelector,
    getItemsSelector,
    isLoadingSelector,
    getCountSelector,
    getPageSelector,
    getPageSizeSelector,
    getCurrentItemsSelector,
} = RessourceSelectorsFactory({
    reducerName: 'APIOrgas',
});
